<template>
    <button :id="item.id" :name="item.id" class="btn btn-outline-primary me-2" @click="$emit('buttonClick', item)">
      {{ item.name }}
    </button>
  </template>
  
  <script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    /*
    methods: {
      handleClick() {
        // Handle the button click event here
        alert('Button clicked!');
      }
    }
    */
  }
  </script>